// A short note at the bottom of the screen (ui/Note.tsx): one at a time, gone after a few seconds.
import { createStore, useStore } from "zustand";

export const noteStore = createStore<{ text: string | null; seq: number }>()(() => ({ text: null, seq: 0 }));
export const useNote = () => useStore(noteStore);
export const showNote = (text: string) => noteStore.setState((s) => ({ text, seq: s.seq + 1 }));
export const hideNote = () => noteStore.setState({ text: null });
